<template>
    <div class="footer-box">
        <div class="footer-item-box">
            <!-- <div class="item-top">
                <div class="logoBox"></div>
                <ul class="navlist">
                    <li class="navitem" v-for='(item,index) in listList' :key='index'><a :href='item.path'
                            class="navfont">{{item.name}}</a></li>
                    <li class="navitem"><a href='/'><i class="iconfont icon-facebook"></i></a><a href='/'><i
                                class="iconfont icon-in"></i></a></li>
                </ul>
            </div> -->
            <div class="item-buttom">
                <ul class="site">
                    <li class="siteli" v-for='(item,index) in siteData' :key='item' v-html="item"></li>
                </ul>
                <div class="QRcode-box">
                    <!-- <div class="QR"></div> -->
                    <img src='https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/shiphao-1.png' class="QR">
                    <span>蓝鲸营销学院</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Footer',
        data() {
            return {
                listList: [
                    {
                        name: '解决方案',
                        path: '/program'
                    },
                    {
                        name: '精彩案例',
                        path: '/case'
                    },
                    {
                        name: '关于我们',
                        path: '/about'
                    },
                    {
                        name: '蓝鲸营销学院',
                        path: '/school'
                    },
                    {
                        name: '联系我们',
                        path: '/contact'
                    }
                ],
                siteData: [
                    '电话：+86 150-5875-1461',
                    '邮件：linglingai@lanjingshuzi.com',
                    '地址：温州龙湾区蒲州街道光电大厦1501室',
                    '版权所有 ©2024 蓝鲸数字科技有限公司 <a href="https://beian.miit.gov.cn">备案证书号:浙ICP备19042095号-1</a>'
                ]
            }
        }
    }
</script>
<style scoped>
    @import url(../../font/ifont/iconfont.css);

    .footer-box {
        padding: 140px 0 91px 0;
        background-color: #1C1C1C;
    }

    .footer-item-box {
        margin: 0 auto;
        grid-template-columns: 1fr;
        max-width: 1434px;
        display: grid;
        margin: 0 auto;
    }

    .item-top {
        padding-bottom: 70px;
        border-bottom: 1px solid rgba(153, 153, 153, .1);
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .item-buttom {
        padding-top: 60px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0 5%;
    }

    .logoBox {
        width: 180px;
        height: 47px;
        background: transparent url('../../assets/LOGO.png') no-repeat center center;
        background-size: cover;
    }

    .navlist {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .navlist>li:not(:last-child) {
        margin-right: 89px;
    }

    .navitem>a {
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(204, 204, 204, 1);
        transition: all 0.5s;
    }

    .navfont:hover {
        color: rgba(255, 255, 255, 1);
    }

    .navitem:last-child .iconfont {
        font-size: 24px;
        color: #999999;
    }

    .navitem:last-child>a:not(:last-child) {
        margin-right: 15px;
    }

    .site {
        width: 490px;
    }

    .siteli {
        font-size: 14px;
        font-weight: 400;
        line-height: 142%;
        color: rgba(204, 204, 204, 1);
    }

    .siteli>>>a{
        color: rgba(204, 204, 204, 1);
        transition: all .3s;
    }

    .siteli>>>a:hover{
        color:#3385ff;
    }

    .siteli:not(:last-child) {
        margin-bottom: 16px;
    }

    .QRcode-box {
        text-align: center;
    }

    .QR {
        display: block;
        height: 100px;
        width: 100px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/ab160ae3-2440-4a47-9e04-e35a748abf06.jpg') no-repeat center center;
    }

    .QRcode-box>span {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(204, 204, 204, 1);
        margin-top: 10px;
        display: inline-block;
    }

    @media(max-width: 995px) {
        .footer-box {
        padding:5% 0;
    }
        .navlist {
            display: none;
        }

        .item-top {
            justify-content: center;
        }

        .logoBox {
            width: 580px;
            height: 147px;
        }

        .item-buttom {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .site {
            width: 100%;
        }

        .siteli {
            font-size:16px;
        }

        .QR {
            margin-top: 20%;
            height: 100px;
            width: 100px;
            margin-bottom: 10%;
        }

        .QRcode-box>span {
            font-size: 16px;
            line-height: 150%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/base/footer.vue